import "core-js/modules/es6.function.name";
import _typeof from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import env from "./env";
var CookieProxy = /*#__PURE__*/function () {
  function CookieProxy(target) {
    _classCallCheck(this, CookieProxy);
    this._target = target;
    this._proxyEnabled = false;
    this._cookies = {};
  }
  _createClass(CookieProxy, [{
    key: "get",
    value: function get(name) {
      var _this$_target;
      if (this._proxyEnabled === true) {
        return _typeof(this._cookies) === 'object' ? this._cookies[name] || '' : '';
      }
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return (_this$_target = this._target).get.apply(_this$_target, [name].concat(args));
    }
  }, {
    key: "set",
    value: function set() {
      var _this$_target2;
      return (_this$_target2 = this._target).set.apply(_this$_target2, arguments);
    }
  }, {
    key: "remove",
    value: function remove() {
      var _this$_target3;
      return (_this$_target3 = this._target).remove.apply(_this$_target3, arguments);
    }
  }, {
    key: "setCookies",
    value: function setCookies() {
      var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._cookies = cookies;
    }
  }, {
    key: "getCookies",
    value: function getCookies() {
      return this._cookies;
    }
  }, {
    key: "enableProxy",
    value: function enableProxy() {
      this._proxyEnabled = true;
    }
  }, {
    key: "disableProxy",
    value: function disableProxy() {
      this._proxyEnabled = false;
    }
  }, {
    key: "isProxyEnabled",
    value: function isProxyEnabled() {
      return this._proxyEnabled;
    }
  }]);
  return CookieProxy;
}(); /**
      * 是否需要使用 Proxy
      * 离线包、服务端渲染场景
      */
export { CookieProxy as default };
export function isNeedUseCookieProxy() {
  return env.isLocalPkg || env.isCSR;
}